import { css } from 'styled-components';
import { colors } from '../colors/colors';
export const typographyLightTheme = {
    basic: css `
    color: ${colors.ultramarine900};
    font-size: 0.875rem;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    line-height: 1.3125rem;
    margin: 0;
  `,
    secondary: css `
    color: ${colors.coolgrey600};
  `,
    bold: css `
    font-weight: 500;
  `,
    error: css `
    color: ${colors.red600};
  `,
    small: css `
    font-size: 0.75rem;
    line-height: 1rem;
  `,
    'code-snippet': css `
    font-family: 'Roboto Mono', monospace;
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.3125rem;
  `,
    heading1: css `
    font-weight: 500;
    font-size: 1.25rem;
    line-height: 1.625rem;
  `,
    heading2: css `
    font-size: 1.125rem;
    line-height: 1.5rem;
  `,
    heading3: css `
    font-size: 1rem;
    line-height: 1.3125rem;
  `,
};
//# sourceMappingURL=light-theme.js.map